import styled from 'styled-components';

import { sizeDown, sizeUp } from '~/theme';

const columnGap = '30rem';

export const Container = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  rowGap: '50rem',
  columnGap,

  paddingBlock: '20rem',
  paddingInline: sizeUp('15rem', ['md', '25rem']),

  '> *': {
    maxInlineSize: '285rem',
    inlineSize: sizeDown(
      `100%`,
      ['md', `calc(50% - ((${columnGap} * 1) / 2))`],
      ['lg', `calc(33.33% - ((${columnGap} * 2) / 3))`]
    ),
  },
});
